export default "__VITE_ASSET__5b9b99ac__"